<template>
  <div class="modalDragSections">
    <div style="border-radius:10px;padding:10px;" class="card">
      <p style="text-align:center" >{{ $t("popupDrag.title") }}</p>
      <hr />
      <section>
        <draggable
          @change="InfiniteWhileInForm(sections)"
          style="z-index:2"
          group="sections"
          :list="sections"
        >
            <div
              style="border-bottom: 1px solid grey; padding:.5em"
              v-for="(section, index) in sections"
              :key="index + 1"
            >
              <div style="display: flex;">
                <div style="cursor: move;margin-right:25px;">
                  <img
              src="@/assets/img/icons/drag-icon.png"
              class="icon-move"
              alt="icon-drop"
            />
                </div>
                <div>
                  <div>{{ section.entitled }}</div>
                  <div style="font-size:.7em">
                    {{ $store.state.question.sections[index].onglet }}{{ " "
                    }}{{ index + 1 }}{{ "/"
                    }}{{ $store.state.question.sections.length }}
                  </div>
                  <p v-if="section.order === error" style="color:red">
                    {{ $t("popupDrag.message") }}
                  </p>
                </div>
              </div>
            </div>
        </draggable>
      </section>
      <div style="text-align:center; margin-top:10px;">
        <button
          style="background-color:#424A60; color:white;"
          @click="validate()"
          class="button is-success"
        >
          {{ $t("button.valider") }}
        </button>
        <button class="button" type="button" @click="cancel()">
          {{ $t("button.annuler") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import EventBus from '@/eventBus'

export default {
  components: {
    draggable
  },
  data () {
    return {
      section: null,
      error: null,
      sectionsEncours: null
    }
  },
  computed: {
    dragOptions () {
      return {
        animation: 0,
        group: 'sections',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    sections: {
      get: function () {
        return this.$store.state.question.sections
      }
    }
  },
  methods: {
    InfiniteWhileInForm () {
      // init
      this.error = null
      this.section = null
      let arrayOfIds = []
      // on pousse les ids des sections dans un array
      this.sections.forEach(section => {
        arrayOfIds.push(section.id)
      })
      this.sections.forEach((section, indexSection) => {
        section.questions.forEach((question, indexQuestion) => {
          question.answers.forEach((answer, indexAnswer) => {
            if (
              answer.conditional_section !== null &&
              answer.conditional_section !== undefined &&
              section.order >= arrayOfIds.indexOf(answer.conditional_section) &&
              answer.conditional_section !== -1
            ) {
              this.error = section.order
              this.section = section
            }
          })
        })
      })
    },
    validate () {
      EventBus.$emit('is-active-popup-drag', {
        type: 'closePopup',
        index: this.indexSection
      })
      if (this.section !== null) {
        this.$store.commit('RESET_ALL_OPTIONS_DRAG', {
          type: 'section',
          data: this.section
        })
      } else {
        this.$store.commit(
          'VALIDATE_CHANGE',
          this.$store.state.question.sections
        )
      }
    },
    cancel () {
      EventBus.$emit('is-active-popup-drag', {
        type: 'closePopup',
        index: this.indexSection
      })
      if (this.section !== null) {
        this.$store.commit('RESET_CHANGE_ORDER_SECTION', {
          section: this.section
        })
      } else {
        this.$store.commit('VALIDATE_CHANGE', this.sections)
      }
    }
  }
}
</script>
<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.sortable-chosen {
  background: #a5a5a5;
}
.button {
  border-radius: 0px;
  font-size: 12px;
  border-radius:4px;
}
.modalDragSections {
  font-size:12px;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  margin:50px;
}
.icon-move {
  min-width: 10px;
  cursor: move;
  height: 18px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/PopupDragSection.vue